<template>
  <div class="shortform-sign-up__partition">
    <span class="shortform-sign-up__partition-text d-none d-md-block">Or</span>
    <span class="shortform-sign-up__partition-text d-md-none">
      {{ mobileText }}
    </span>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    mobileText?: string
  }>(),
  {
    mobileText: 'Sign in with',
  },
)
</script>
